import type { CategoryPageHeaderAttributes } from '../../types/cms'
import { CategoryPageHeaderContainer } from './styles'
import { Container, Stack } from '@mui/material'
import { MarkdownText } from 'ui-kit'
import FormattedImage from '../FormattedImage'

const CategoryPageHeader = ({
  category,
  subCategory,
  backgroundColour = '#031126',
  categoryTextColour = '#3A72C3',
  subCategoryTextColour = '#FFF',
  image = {},
}: CategoryPageHeaderAttributes) => {
  return (
    <CategoryPageHeaderContainer
      backgroundColour={backgroundColour}
      categoryTextColour={categoryTextColour}
      subCategoryTextColour={subCategoryTextColour}
    >
      <Container maxWidth="sm">
        <Stack justifyContent={'center'} alignItems={'center'}>
          {image?.data ? (
            <FormattedImage image={image} />
          ) : (
            <>
              <MarkdownText>{category}</MarkdownText>
              <MarkdownText>{subCategory}</MarkdownText>
            </>
          )}
        </Stack>
      </Container>
    </CategoryPageHeaderContainer>
  )
}

export default CategoryPageHeader
